export default {
  date: 'Date',
  chooseExpDate: 'Choisissez la date',
  filterExpDate: 'Choisissez la date',
  experienceType: 'Type',
  filterExperienceType: 'Filtrer par type',
  experienceVibe: 'Ambiance',
  filterExperienceVibe: 'Filtrer par ambiance',
  search: 'Rechercher',
  viewCalendar: 'Voir le Calendrier',
  back: 'Retour',
  previous: 'Précédent',
  next: 'Suivant',
  noExperiences: 'Pas d’expériences trouvées',
  selectDate: 'Choisir la date',
  startDate: 'Date de départ',
  endDate: 'Date de fin',
  submit: 'Envoyer',
  filterExperienceTypeScreenReader:
    'Utilisez ces filtres pour affiner les résultats. Le contenu se met à jour automatiquement lorsqu’un filtre est sélectionné.',
};
